// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__hnL6C","errorLabel":"Label_errorLabel__3fIt4"};